<template>
<v-dialog v-model="showAlert" width="500" persistent>
    <v-card :loading="$store.state.isLoading">
        <v-card-title>Was ist zu beachten?</v-card-title>
        <v-card-text v-if="!editMode" v-html="consideredText"></v-card-text>
        <v-card-text v-else>
            <v-textarea v-model="consideredText" outlined auto-grow></v-textarea>
        </v-card-text>
        <v-card-actions>
            <v-btn v-if="!editMode && $store.state.auth.userClaims.campaign" text icon @click="edit"><v-icon>mdi-pencil</v-icon></v-btn>
            <v-btn v-else-if="$store.state.auth.userClaims.campaign" text @click="showAlert = false">Abbrechen</v-btn>
            <v-spacer></v-spacer>
            <v-btn v-if="!editMode" text @click="showAlert = false">OK</v-btn>
            <v-btn v-else text @click="save">Speichern</v-btn>
        </v-card-actions>
    </v-card>
</v-dialog>
</template>
<script>
import { collection, doc, updateDoc } from '@firebase/firestore';
import { firestore } from '../../firebase';
export default {
    data() {
        return {
            consideredText: "",
            editMode: false,
            showAlert: false
        }
    },
    methods: {
        edit() {
            this.consideredText = this.consideredText.replace(/<br>/g, "\n");
            this.editMode = true;
        },
        save() {
            this.$store.state.isLoading = true;
            updateDoc(doc(collection(firestore, "configuration"), "campaign"), {
                consideredText: this.consideredText.replace(/(?:\r\n|\r|\n)/g, '<br>')
            }).then(() => {
                location.reload();
            }).catch(error => {
                this.alert.title = "Fehler";
                this.alert.message = "Es ist ein unbekannter Fehler aufgetreten. Bitte versuchen Sie es später erneut!";
                this.alert.active++;
            });
        }
    },
    watch: {
        active() {
            this.showAlert = true;
            this.editMode = false;
            this.consideredText = this.$store.state.config.campaign.consideredText;
        }
    },
    props: {
        active: Number
    }
}
</script>